import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql, navigate } from "gatsby";
import { storyblokEditable } from "gatsby-source-storyblok"
import { getCookie, setCookie } from "../../global/helpers"

// This function is for toggling closing and opening the dropdown list
const toggleClassOpen = () => {
  const optionsMenu = document.getElementById('new_options');
  if (optionsMenu.classList.contains('open')) {
    optionsMenu.classList.remove('open');
  } else {
    optionsMenu.classList.add('open');
  }
};

const Form = ({ blok }) => {
  const [formReady, setFormReady] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [newList, setNewList] = useState(null);
  const forms = useStaticQuery(
    graphql`
      query {
        allStoryblokEntry(filter: {field_component: {in: ["form"]}}) {
          nodes {
            content
            uuid
            name
          }
        },
        storyblokEntry(slug: {eq: "global-settings"}) {
          content
        }
      }
    `
  )

  let form_embed = function (forms, ID) {
    var form = "";
    for (let i = 0; i < forms.allStoryblokEntry.nodes.length; i++) {
      if (forms.allStoryblokEntry.nodes[i].uuid === ID) {
        form = JSON.parse(forms.allStoryblokEntry.nodes[i].content)
      }
    }

    return form;
  }

  const data = form_embed(forms, blok.Form); 
  const portal_id = JSON.parse(forms.storyblokEntry.content).hubspot_portal_id;   

  const handleSubmit = (formData) => { 
       
    // If OnetrustActiveGroups is not undefined and if it includes Functional Cookies
    if(typeof window.OnetrustActiveGroups !== "undefined" && window.OnetrustActiveGroups.includes("C0003")){
        // set cookie. 
        setCookie(formData);  
    }
    
    setFormSubmitted(true);

    // Destroy observer
    window.formObserver.disconnect();

    //Redirect to thank you page.
    navigate(`/thank-you`, { state: { data } });
  }

  const handleReady = (form) => {
    setFormReady(true);
    //Add custom classes to button container element
    const actions = form.querySelector(".actions");
    actions && actions.classList.add("button", blok.Style, blok.button_alignment);

    // Options for the observer (which mutations to observe)
    const config = {childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "subtree") {
          //Add a bit of extra validation styling.
          // Migrated from deprecated Mutation event: DOMSubtreeModified
          mutation.target.classList.remove('hs-error');
          if ( mutation.target.getElementsByClassName("hs-error-msgs").length > 0 ) { 
            mutation.target.classList.add('hs-error');
          } 
        }
      }
    };

    window.formObserver = new MutationObserver(callback);
    window.formObserver.observe(form, config);
  }
  
  // use effect for fetching HB form and placing in the component
  useEffect(() => {   

    const cookieData = getCookie( data.form_id ); //Parse cookie saved on form submit
    const pagePath = (typeof window !== 'undefined') ? window.location.pathname.replace(/\/(.*)\//, '$1') : ""; //Remove first and last / from location to match full_slug

    //Creat object to store formData used in submit function
    const formData = { 
      last_converting_page: pagePath,
      cookie_expire: data.cookie_expire,
      cookie_name: data.form_id,
      gate_form: data.gate_form, //true or false
      unlocked_pages: (cookieData) ? cookieData.unlocked_pages : [],
    }      

    //A form could be on multiple pages. Adding the page url allows us gate or ungate the same Form ID on multiple pages
    if ( !formData.unlocked_pages.includes( pagePath ) ) { 
      formData.unlocked_pages.push( pagePath ); 
    }  

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: portal_id,
          formId: data.form_id,
          target: '#hubspotForm',
          groupErrors: false,
          submitButtonClass: 'hs-button',
          //errorClass: "errorHand", 
          onFormSubmitted: form => handleSubmit(formData),
          onFormReady: form => handleReady(form)
        })
      }
    }); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect for checking for dropdown menu; 
  // If there is a dropdown menu, Options value are stored in NewList State
  useEffect(() => {
    if (!formReady) return;
    const dropDownMenu = document.querySelectorAll('.hs-fieldtype-select select');
    if (dropDownMenu.length === 0) {
      return
    };
    const options = dropDownMenu[0].children
    let arr = [];
    for (let i = 0; i < options.length; i++) {
      const element = [
        options[i].value,
        options[i].innerText
      ]
      arr.push(element)
    }
    // skipping first selection
    arr.shift()
    setNewList(arr);
  }, [formReady]);



  useEffect(() => {
    if (!newList) return;
    const dropDownMenuSelect = document.querySelectorAll('.hs-fieldtype-select .input');
    const dropDownMenuInputs = document.querySelectorAll('.hs-fieldtype-select');
    if (!newList) return;

    dropDownMenuSelect[0].insertAdjacentHTML("beforeend",
      `
      <div class="select-menu"> 
      <div id="select_new_options">Please select</div>
      <i class="arrow"></i>
      </div>
      `)
    dropDownMenuInputs[0].insertAdjacentHTML("beforeend",
      `
          <ul id="new_options">
          ${newList.map(item =>
        `
            <li class="newOptions" value=${item[0]} >${item[1]}</li>
            `
      ).join('')
      }
          </ul>
        `
    )

    const optionsList = document.getElementsByClassName('newOptions');
    for (let i = 0; i < optionsList.length; i++) {
      optionsList[i].addEventListener('click', (event) => { setAttValue(event); })
    };

    const newSelect = document.getElementsByClassName('select-menu');  
    if (!newSelect || !newSelect.length) return; 
    newSelect[0].addEventListener('click', toggleClassOpen);

  }, [newList]);


  // This function is for setting the value
  const setAttValue = (event) => {
    const optionsList = document.getElementsByClassName('newOptions');

    for (let i = 0; i < optionsList.length; i++) {
      optionsList[i].classList.remove('active')
    }
    event.target.classList.add('active');

    const newSelect = document.getElementById('select_new_options');
    newSelect.innerText = event.target.innerText;
    toggleClassOpen();
  }


  return (
    <div className="component form" {...storyblokEditable(blok)}>
      <div id="hubspotForm" className={formSubmitted ? 'submitted' : ''} />
      {formSubmitted && <p>Redirecting...</p>}
    </div>
  )
}

export default Form
